import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateParameter } from "../../services/parameter";
import { IIndicators } from "../../types";
import { toast } from "react-toastify";

const useUpdateParameter = (indicators: IIndicators) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: updateParameter,

        onMutate: () => {
            indicators.setIsProcessRunning(true);
        },

        onSuccess: (status) => {
            if (status === 200) {
                indicators.setIsProcessRunning(false);
                queryClient.invalidateQueries({ queryKey: ['categories'] });
                toast.success("Parameter updated successfully");
            }
        },

        onError: (error: any) => {
            indicators.setIsProcessRunning(false);
            indicators.setIsServiceError(error.response?.data?.message);
            toast.error(error.response?.data?.message);
        }
    });
}

export default useUpdateParameter;